import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PageMeta from "../../components/common/page-meta";
import HagahLandingPage from "../../assets/hagah/final_background.svg";
import {
  ArtworkImage,
  ArtworkStage,
  BackHitArea,
  HagahPage,
  ScreenReaderSummary,
  SupportHitArea,
} from "./style";

const Hagah = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Hagah — Stay with the Word";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <HagahPage>
      <PageMeta
        title="Hagah — Stay with the Word"
        description="A quiet daily practice for reading, reciting, remembering, and reflecting on Scripture."
      />
      <ArtworkStage>
        <ArtworkImage
          src={HagahLandingPage}
          alt="Hagah landing page: Coming soon. Stay with the Word. A quiet practice for meditating on Scripture."
        />

        <BackHitArea as={Link} to="/" aria-label="Back to Freddy">
          <span>Back to Freddy</span>
        </BackHitArea>

        <SupportHitArea
          href="https://buymeacoffee.com/freddyas"
          target="_blank"
          rel="noreferrer"
          aria-label="Support Hagah"
        >
          <span>Support Hagah</span>
        </SupportHitArea>

        <ScreenReaderSummary>
          <h1>Coming soon: Stay with the Word</h1>
          <p>
            Hagah helps you meditate on Scripture by reading, reciting,
            remembering, and reflecting on God&apos;s Word throughout your day.
          </p>
          <h2>Scripture worth staying with</h2>
          <p>
            We read many things every day. Hagah helps you slow down and spend
            a little more time with the Word before moving on.
          </p>
          <p>
            Hagah is a Hebrew word that can carry the sense of murmuring,
            speaking, pondering, or reciting. In Joshua 1:8, Joshua is told to
            meditate on the Book of the Law day and night.
          </p>
        </ScreenReaderSummary>
      </ArtworkStage>
    </HagahPage>
  );
};

export default Hagah;
